import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { MapPin } from 'lucide-react';

const ZoneMapModal = ({ mapUrl, zones }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-none gap-1 h-6 text-[11px] px-2 py-0" data-testid="view-zones-btn">
          <MapPin className="w-3 h-3" />
          Zones
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Zones de livraison</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {!imageLoaded && (
            <div className="w-full aspect-square bg-gray-100 animate-pulse flex items-center justify-center">
              <span className="text-sm text-muted-foreground">Chargement...</span>
            </div>
          )}
          <img
            src={mapUrl}
            alt="Carte des zones de livraison"
            className={`w-full h-auto border border-border ${imageLoaded ? '' : 'hidden'}`}
            onLoad={() => setImageLoaded(true)}
            loading="eager"
            decoding="async"
            data-testid="zone-map-image"
          />
          {zones && zones.length > 0 && (
            <div className="grid grid-cols-2 gap-2" data-testid="zone-legend">
              {zones.map((z) => (
                <div key={z.name} className="flex items-center gap-2 text-sm">
                  <span
                    className="w-4 h-4 rounded-full flex-shrink-0 border border-border"
                    style={{ backgroundColor: z.color }}
                  />
                  <span className="font-medium">{z.name}</span>
                  {z.surcharge === -1 ? (
                    <span className="text-orange-500 text-xs">(sur devis)</span>
                  ) : z.surcharge > 0 ? (
                    <span className="text-muted-foreground text-xs">(+{z.surcharge} EUR)</span>
                  ) : (
                    <span className="text-muted-foreground text-xs">(+0 EUR)</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ZoneMapModal;
